import React, { Component } from "react";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import StaticClass from "../../../utils/staticClass";
export default class SearchResult5000 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "DuAn",
    };

    this.listDuAnTitle = [
      "Mã phân khu",
      "Tên phân khu",
      "Mã quy hoạch chung",
      "Diện tích (ha)",
      "Số quyết định pháp lý",
      "Năm ra quyết định pháp lý",
      "Cơ quan phê duyệt dự án",
      "Vị trí",
      "Năm quy hoạch",
      "Tình trạng",
      "Ghi chú",
    ];

    this.listDuAnValue = [
      "MaPhanKhu",
      "TenPhanKhu",
      "MaQHChung",
      "DienTich",
      "QuyetDinhPhapLy",
      "NamRaQDPL",
      "CoQuanpheDuyet",
      "ViTri",
      "NamQH",
      "TinhTrang",
      "GhiChu",
    ];

    this.listTienDo = [
      {
        value: 0,
        name: "-",
      },
      {
        value: 1,
        name: "Cơ bản hoàn thành",
      },

      {
        value: 2,
        name: "Đang triển khai",
      },

      {
        value: 3,
        name: "Chưa triển khai",
      },

      {
        value: 4,
        name: "Chậm triển khai",
      },
    ];
  }

  changeTab(e) {
    this.setState({
      activeTab: e,
    });
  }

  render() {
    let convertData = undefined;
    if (this.props.data && this.props.data.TinhTrang) {
      convertData = {
        ...this.props.data,
        TinhTrang: this.listTienDo[this.props.data.TinhTrang].name,
      };
    } else {
      convertData = this.props.data;
    }
    return (
      <div className="search-500">
        <div className="search-500-header">
          Thông tin dự án quy hoạch 1/5000
          <i className="fas fa-times close-icon" onClick={this.props.close}></i>
        </div>

        <div className="search-500-body">
          {this.listDuAnTitle.map((e, i) => (
            <div style={{ display: "flex" }} key={i}>
              <div className="col-left search-500-text" style={{marginRight: 0, width: 145}} >
                {e}:
              </div>

              <div className="col-right search-500-text-gray" style={{ maxWidth: 185}} >
                {i === 5
                  ? convertData[`${this.listDuAnValue[i]}`]
                    ? new Date(
                        convertData[`${this.listDuAnValue[i]}`]
                      ).getFullYear()
                    : "-"
                  : convertData[`${this.listDuAnValue[i]}`]
                  ? i === 3
                    ? StaticClass.formatPrice(
                        `${convertData[`${this.listDuAnValue[i]}`]}`
                      )
                    : `${convertData[`${this.listDuAnValue[i]}`]}`
                  : "-"}
              </div>
            </div>
          ))}

          {this.props.file && Array.isArray(this.props.file) && this.props.file.length !== 0 && (
            <div style={{ display: "flex" }}>
              <div className="col-left search-500-text" style={{marginRight: 0, width: 145}}>File đính kèm:</div>
              <div>
                {this.props.file.map((e, i) => (
                  <div
                    className="col-right search-500-text"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "125px",
                      color: "#1e86eb",
                      cursor: "pointer",
                      maxWidth: 185
                    }}
                    onClick = {async()=>{
                      const response = await AxiosGetSecretApi(`/api/otp-token`);
                      window.open(`${e.Duongdanfiledinhkem}?key=${response.token}`, "_blank")
                    }}
                  >
                    {e.Tenfiledinhkem}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
